import BigNumber from "bignumber.js";
export function serialize({ amount, recipient, family, mode, fees, }) {
    return {
        amount: amount.toString(),
        recipient,
        family,
        mode,
        fees: fees?.toString(),
    };
}
export function deserialize({ amount, recipient, family, mode, fees, }) {
    return {
        amount: new BigNumber(amount),
        recipient,
        family,
        mode,
        fees: fees ? new BigNumber(fees) : undefined,
    };
}
//# sourceMappingURL=serializer.js.map